import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DefaultLanguage } from '@shared/constants/constants';
import { PrimeNGConfig } from 'primeng/api';

@Injectable()
export class TranslatorService {

    // Default language as fallback
    private defaultLanguage = DefaultLanguage;

    private availablelangs = [
        { code: 'en', text: 'English' },
        { code: 'nl', text: 'Dutch' },
        { code: 'fr', text: 'French' },
        { code: 'de', text: 'German' },
        { code: 'sv', text: 'Swedish' },
        { code: 'es', text: 'Spanish' },
        { code: 'it', text: 'Italian' },
        { code: 'nb', text: 'Norwegian' },
        { code: 'da', text: 'Danish' },
        { code: 'lt', text: 'Lithuanian' },
        { code: 'fi', text: 'Finnish' },
        { code: 'lv', text: 'Latvian' },
        { code: 'cs', text: 'Czech' },
        { code: 'sl', text: 'Slovenian' },
        { code: 'ru', text: 'Russian' },
        { code: 'uk', text: 'Ukrainian' },
        { code: 'tr', text: 'Turkish' },
        { code: 'el', text: 'Greek' },
        { code: 'pt', text: 'Portuguese' },
        { code: 'pl', text: 'Polish' },
        { code: 'sk', text: 'Slovak' }
    ];

    constructor(
        public translate: TranslateService,
        private primeNgConfig: PrimeNGConfig
    ) {
        // Get language using navigator of browser (user agent)
        if (this.availablelangs.find(x => x.code === navigator.language?.substring(0, 2))) {
            this.defaultLanguage = navigator.language?.substring(0, 2);
        }

        if (!translate.getDefaultLang()) {
            translate.setDefaultLang(this.defaultLanguage);
        }

        this.useLanguage();
    }

    public useLanguage(lang: string = null) {
        this.translate.use(lang || this.translate.getDefaultLang()).subscribe(() => {
            // Change PrimeNG locale
            this.translate.get('primeng').subscribe(res => this.primeNgConfig.setTranslation(res));
        });
    }

    public getAvailableLanguages() {
        return this.availablelangs;
    }

}
